import { ProgressSpinner } from 'primereact/progressspinner';

export interface LoadingIndicatorProps {
  inline?: boolean;
}

export const LoadingIndicator = ({ inline = true }: LoadingIndicatorProps) => {
  if (inline) {
    return <ProgressSpinner />;
  }
  return (
    <div
      style={{
        display: 'grid',
        alignItems: 'center',
        width: '100%',
        height: '100dvh',
      }}
    >
      <ProgressSpinner />
    </div>
  );
};
